import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'

export const RiverPositionSchema = z.enum([
  'bottom-left',
  'bottom-center',
  'bottom-right',
  'center-left',
  'center-center',
  'center-right',
  'top-left',
  'top-center',
  'top-right',
])

export const LabelAssetLinkItemSchema = buildEntrySchemaFor('labelAssetLinkItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      description: RichTextSchema,
      href: z.string().optional(),
      label: z.string().optional(),
      alt: safeOptional(z.string()),
      eyebrow: z.string().optional(),
      assetType: z.enum(['Image', 'Uploaded Video', 'External Video']).optional(),
      optionImage: AssetSchema.optional(),
      optionVideo: AssetSchema.optional(),
      optionPoster: AssetSchema.optional(),
      autoplay: z.boolean().optional(),
      videoSource: z.string().optional(),
      position: RiverPositionSchema.optional(),
    }),
  ),
})
export type RiverPosition = z.infer<typeof RiverPositionSchema>
export type LabelAssetLinkItem = z.infer<typeof LabelAssetLinkItemSchema>
